module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image2e.04df116c.jpg";